export default __webpack_public_path__ + "static/media/Reminder.54822cc6.png";